import { render } from "./RelationsTable.vue?vue&type=template&id=2fdc92cb&scoped=true"
import script from "./RelationsTable.vue?vue&type=script&lang=js"
export * from "./RelationsTable.vue?vue&type=script&lang=js"

import "./RelationsTable.vue?vue&type=style&index=0&id=2fdc92cb&scoped=true&lang=scss"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdc92cb"]])

export default __exports__